// extracted by mini-css-extract-plugin
export const formContainer = "contactForm-module--formContainer--2oqxT";
export const form = "contactForm-module--form--2nEqu";
export const successMessage = "contactForm-module--successMessage--3EDyO";